// Server-side PDF generation via Netlify function + headless Chromium

import { supabase } from '../lib/supabase';

export async function generateReportPDF(html: string): Promise<Blob> {
  // The function requires a signed-in caller (it renders arbitrary HTML in a
  // headless browser, which is expensive enough to be worth abusing). getSession
  // refreshes an expired token rather than handing over one the function will
  // reject.
  const { data: { session } } = await supabase.auth.getSession();
  if (!session?.access_token) {
    throw new Error('PDF generation requires an active session. Sign in and try again.');
  }

  const response = await fetch('/.netlify/functions/generate-pdf', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${session.access_token}`,
    },
    body: JSON.stringify({ html }),
  });

  if (!response.ok) {
    const err = await response.text();
    throw new Error(`PDF generation failed: ${err}`);
  }

  const { pdf } = await response.json();
  const binary = atob(pdf);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return new Blob([bytes], { type: 'application/pdf' });
}
